import React, { useContext } from "react";
import { DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";
import { Place } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";
import { useGeometryTypeCheck } from "./useGeometryTypeCheck";

const PointButton: React.FC<IButtonProps> = ({ icon, title = "Draw a point" }) => {
  const { map, drawControl } = useContext(MapContext);
  const isPointLayer = useGeometryTypeCheck("Point");

  const handleOnClick = () => {
    if (!drawControl.current) return;
    drawControl.current.changeMode("draw_point");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "draw_point" } as DrawModeChangeEvent);
  };

  return (
    <ToolbarToggleButton title={title} value="draw_point" onClick={handleOnClick} data-testid="toolbar-point-button" disabled={!isPointLayer}>
      {icon || <Place />}
    </ToolbarToggleButton>
  );
};

export default PointButton;
